<template>
  <div class="input-card--container">
    <div class="container-list">
      <input
        type="text"
        v-model="inputCode"
        class="secondary-input input-code"
        placeholder="Ex.: XXXX-XXXX-XXXX"
        @input="qrCodeFormatInput"
        @focus="handleFocus"
      />
      <button class="primary-button validate-btn" :disabled="!inputCode" @click="handleSubmit">
        Validar
      </button>
    </div>
    <button class="link-button" @click="readQrCode">Ler QR Code</button>
  </div>
</template>
<script>
export default {
  data() {
    return {
    };
  },
  props: ["isSuccess", "message", 'inputCode'],
  emits: ["onSubmit", "onReadQrCode", 'onFocus', 'onBlur'],
  methods: {
    handleSubmit() {
      this.$emit("onSubmit", this.inputCode);
    },
    readQrCode() {
      this.$emit("onReadQrCode");
    },
    handleFocus(){
      this.$emit("onFocus");
    },
    qrCodeFormatInput() {
      this.inputCode = this.inputCode
        .replace(/[^a-zA-Z0-9]/g, "")
        .toUpperCase()
        .slice(0, 12)
        .replace(/(.{4})(?=.)/g, "$1-");
    },
  },
};
</script>

<style scoped>
.input-card--container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 90%;
}

/* .input-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
} */

.validate-btn {
  /* padding: 12px 0px; */
  /* font-size: 14px; */
  width: 60%;
  /* background-color: #de3517; */
  /* color: #fff;
  border: none;
  border-radius: 6px; */
  margin-top: 15px;
  /* cursor: pointer; */
/*   transition: background 0.3s ease;

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  } */
}

/* .input-option--btn {
  font-size: 14px;
  color: #de3517;
  opacity: 0.8;
  font-weight: 500;
  text-decoration: underline;
  margin-top: 10px;
  background-color: transparent;
  border: none;
} */

.input-code {
  width: 60%;
}
</style>
